import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { CdiInvoiceResolutionRequestDto } from "../../../core/models/cdi/CDIInvoiceResolutionRequestDto";
import { OcrInvoiceMatchingNotes } from "../../../core/models/cdi/CDINotes";
import { CDISummaryService } from "../../../core/services/cdi-resolution-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-cdi-disposition",
  templateUrl: "./cdi-disposition.component.html",
  styleUrls: ["./cdi-disposition.component.scss"],
  imports: [CommonModule, FormsModule, SelectModule, SpinnerComponent],
})
export class CdiDispositionComponent implements OnInit {
  cdiAction = [
    { name: "None", value: "None" },
    { name: "Pending", value: "Pending" },
    { name: "ApproveToMatch", value: "Approve to match vendor net cost" },
    { name: "AddToFreight", value: "Add to freight" },
    { name: "AddNetLine", value: "Add net line" },
    { name: "PendingCredit", value: "Pending credit / RA in route" },
    { name: "NotApproved", value: "Not approved - BC/BAC contacting vendor" },
    { name: "NoActionNeeded", value: "No action needed - BC/BAC resolved CDI" },
    { name: "AutoClose", value: "Auto closed" },
  ];

  cdiActionVal = "";
  showSmallLoader = false;
  recId = "";
  tableId = "";
  clientName = "";
  orderNumber = "";
  jobName = "";
  vendorName = "";
  reason = "";
  cdiNotesGridListing: OcrInvoiceMatchingNotes[] = [];

  constructor(
    private _loaderService: LoaderService,
    private _activatedRoute: ActivatedRoute,
    private _cdiSummaryService: CDISummaryService,
    private _toastr: JniToastrService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.recId = params["recId"];
      this.tableId = params["tableId"];
    });
  }

  ngOnInit(): void {
    this.getCdiDispositionDetails(Number.parseInt(this.recId));
    this.getCDINotes(Number.parseInt(this.recId));
  }

  onCdiActionSubmit() {
    this._loaderService.setLoaderState(true);

    const cdiInvoiceResolutionFormObject = {
      recId: this.recId,
      processOCRInvoice: 1,
      tableId: this.tableId?.toString() ?? "",
      cDIAction: this.cdiActionVal,
    } as CdiInvoiceResolutionRequestDto;

    this._cdiSummaryService
      .SubmitCdiInvoiceResolution(cdiInvoiceResolutionFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          // this.getCdiSummaryEvent.emit(this.cdiRecId);
          if (res?.status?.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              res.message || "CDI resolution submitted successfully"
            );
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error submitting cdi resolution"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error submitting cdi resolution"
          );
        },
      });
  }

  // getCdiSummary(recId: number) {
  //   this._cdiSummaryService
  //     .getCDISummary(recId)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this._loaderService.setLoaderState(false);
  //         if (res.data) {
  //           this.cdiActionVal = res.data.rsmJNICDIActionD365;
  //           this.clientName = res.data.customerNameD365;
  //           this.orderNumber = res.data.salesOrderD365;
  //           this.vendorName = res.data.vendorNameD365;
  //           this.reason = res.data.reasonD365;
  //         }
  //       },
  //       error: (res) => {
  //         this._loaderService.setLoaderState(false);
  //       }
  //     });
  // }

  getCdiDispositionDetails(recId: number) {
    this._cdiSummaryService
      .getCdiDispositionDetails(recId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.cdiActionVal = res.data.rsmJNICDIActionD365;
            this.clientName = res.data.customerNameD365;
            this.orderNumber = res.data.salesOrderD365;
            this.vendorName = res.data.vendorNameD365;
            this.reason = res.data.reasonD365;
            this.jobName = res.data.jobNameD365;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getCDINotes(recId: number) {
    this._loaderService.setLoaderState(true);
    this._cdiSummaryService
      .getCDINotes(recId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.cdiNotesGridListing = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }
}
